import { Component, Inject, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationFacade, Itinerary, OpenTripPlannerFacade, SearchService } from '@ridango/components';
import { Share } from '@capacitor/share';
import Env from '@ridango/core/env';
import { Router } from '@angular/router';
import { MapApiService } from '../../map/services/map-api.service';
import { BaseComponent } from '@ridango/core';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-itinerary-details-header',
    templateUrl: './itinerary-details-header.component.html'
})
export class ItineraryDetailsHeaderComponent extends BaseComponent implements OnInit {
    @Input() itinerary: Itinerary;
    @Input() currentTime: number;
    assetsPath$ = this.applicationFacade.assetsPath$;
    search$ = this.openTripPlannerFacade.search$;
    search;
    date: Date;

    constructor(
        @Inject('ENV') public env: Env,
        private router: Router,
        private applicationFacade: ApplicationFacade,
        private translate: TranslateService,
        private readonly searchService: SearchService,
        private mapApi: MapApiService,
        private openTripPlannerFacade: OpenTripPlannerFacade
    ) {
        super();
    }

    ngOnInit() {
        this.search$.pipe(takeUntil(this.componentDestroyed$)).subscribe((result) => {
            this.search = result;
        });
    }

    async navigateBack(): Promise<void> {
        this.mapApi.removeStopsFromMap();
        await this.router.navigate([this.translate.currentLang, 'journey-planner', 'result']).then(() => {
            this.openTripPlannerFacade.setSelectedItineraryForDetails(null);
        });
    }

    private getCurrentBaseUrl(): string {
        return `${this.env.BASE_URL}${this.translate.currentLang}/journey-planner/result`;
    }

    public exportTravelPlan(): void {
        if (!this.itinerary) return;
        const url = `${this.getCurrentBaseUrl()}?${this.searchService.getParamsForUrl(this.itinerary)}`;
        this.shareUrl(url);
    }

    private getLocationDisplayName(location: any): string {
        if (!location) return '';

        if (location.name === 'LOCATION_FROM_MAP') {
            return this.translate.instant('LOCATION_FROM_MAP');
        }

        if (location.name === 'CURRENT_LOCATION') {
            return this.translate.instant('CURRENT_LOCATION');
        }

        return location.name;
    }

    private async shareUrl(url: string): Promise<void> {
        const originName = this.getLocationDisplayName(this.search?.origin);
        const destinationName = this.getLocationDisplayName(this.search?.destination);

        await Share.share({
            url: url,
            title: this.translate
                .instant('SHARED_JOURNEY_TITLE')
                .replace('${0}', originName)
                .replace('${1}', destinationName),
            text: this.translate
                .instant('SHARED_JOURNEY_TEXT')
                .replace('${0}', originName)
                .replace('${1}', destinationName)
        });
    }
}
